module.exports = __webpack_public_path__ + "assets/img/abtd.cecfec9a.png";